import { Observable, Subject } from 'rxjs';

interface IVideo {
    title: string;
    src: string;
}

export class VideoService {
    private readonly _play$ = new Subject<IVideo>();

    get play$(): Observable<IVideo> {
        return this._play$.asObservable();
    }

    playVideo(title: string, src: string): void {
        this._play$.next({
            title,
            src
        });
    }
}
